/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query ContactBookReadUniqueQuery($contactBookId: ID!) {
  ContactBookReadUnique(contactBookId: $contactBookId) {
    id,
    contactBook,
    message,
    status
  }
}
`
